import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import baoRouter from "./../../services/bao-router";
import TabPage from "./../../factories/tab-page";
import TabController from "./../../factories/tab-controller";
import InformationDurationReportTabResultListViewModel from "./information-duration-report-tab-result-list-view-model";
import InformationDurationReportTabResultDiagramViewModel from "./information-duration-report-tab-result-diagram-view-model";
import "./../../bindings/bao-tabs";
import "./../../bindings/bao-date-time-picker";
import "./../../bindings/bao-date-time-box";
function InformationDurationReportViewModel(parent) {
    var self = this;
    self.parent = parent;
    self.Bao = Bao;
    self.Initialized = ko.observable(false);
    self.ReportLoaded = ko.observable(false);
    self.StartDateTime = ko.observable();
    self.EndDateTime = ko.observable();
    self.AreaId = ko.observable();
    self.AreaName = ko.observable();
    self.AreaEquipmentId = ko.observable();
    self.AreaEquipmentName = ko.observable();
    self.AvailableLimits = ko.observableArray();
    self.Limit = ko.observable();
    self.TabViewModel = new TabController(false);
    self.Models = ko.observableArray([]);
    self.AllModels = ko.observableArray([]);
    self.PageIndexDefault = 0;
    self.PageSizeDefault = 10;
    self.PageIndex = ko.observable(self.PageIndexDefault);
    self.PageSize = ko.observable(self.PageSizeDefault);
    self.TotalRows = ko.observable(0);
    self.Sorting = ko.observable([]);
    self.ResultTabList = null;
    self.ResultTabDiagram = null;
    self.CaptionDatasieriesname = ko.observable("data1");
    self.chartColors = [];
    self.DiagramDataSet = ko.pureComputed(function () {
        var entries = self.AllModels();
        var data = {
            x: "x",
            columns: [["data1"], ["x"]],
            types: {
                data1: "bar"
            },
            names: {
                data1: self.CaptionDatasieriesname()
            },
            labels: true,
            color: function (color, d) {
                if (d.index != null && self.chartColors != null) {
                    return self.chartColors[d.index];
                }
                return "#1f77b4";
            }
        };
        if (entries.length > 0) {
            for (var i in entries) {
                var y = ko.unwrap(entries[i].Duration);
                if (typeof y === "undefined" || y === null) {
                    y = 0;
                }
                data.columns[0].push(y);
                var label = ko.unwrap(entries[i].CategoryFullName);
                if (typeof label === "undefined" || label === null) {
                    label = "";
                }
                data.columns[1].push(label);
                var color = ko.unwrap(entries[i].ColorString);
                if (typeof color === "undefined" || color == null) {
                    color = "#1f77b4";
                }
                self.chartColors.push(color);
            }
        }
        return data;
    });
    self.IsReportResultEmpty = ko.pureComputed(function () {
        return Boolean(self.ReportLoaded() && typeof self.Models() !== "undefined" && self.Models().length === 0);
    });
    self.PageIndex.subscribe(function () {
        if (self.Initialized() && self.ReportLoaded()) {
            parent.TabPage.IsLoading(true);
            self.RefreshModels().done(function () {
                self.ReportLoaded(true);
                parent.TabPage.IsLoading(false);
            });
        }
    });
    self.Sorting.subscribe(function () {
        if (self.Initialized() && self.ReportLoaded()) {
            parent.TabPage.IsLoading(true);
            $.when(self.RefreshModels(), self.RefreshDiagramModels()).done(function () {
                self.ReportLoaded(true);
                parent.TabPage.IsLoading(false);
            });
        }
    });
    self.Download = function () {
        if (!self.IsComplete()) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("SelectOneTag"), "info");
            return;
        }
        if (!self.IsValidDateFields()) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("DateTimeFieldsAreInvalid"), "info");
            return;
        }
        var filterlist = ["StartDateTime", "AreaId", "AreaName", "AreaEquipmentId", "AreaEquipmentName"];
        var filter = self.GetFilterHashObject(filterlist, self);
        filter.push({
            Key: "Limit",
            Value: 10
        });
        var data = {
            filter: filter,
            sorting: []
        };
        self.parent.DownloadReport("InformationDurationReport", data);
    };
    self.GetFilterHashObject = function (filterlist) {
        //Add one Day to include the selected End Date in the Filter.
        let correctedEndDateTime = self.ConvertToDateTime(this.EndDateTime());
        correctedEndDateTime.setDate(correctedEndDateTime.getDate() + 1);

        var filter = self.parent.GetFilterHashObject(filterlist, self);
        filter.push({
            Key: "EndDateTime",
            Value: this.ConvertToDateString(correctedEndDateTime)
        });
        return filter;
    };
    self.IsComplete = function () {
        return Boolean(!Bao.Utils.String.IsNullOrEmpty(self.StartDateTime()) && !Bao.Utils.String.IsNullOrEmpty(self.EndDateTime()));
    };
    self.IsValidDateFields = function () {
        return Boolean(Bao.Utils.String.IsNullOrEmpty(self.StartDateTime()) || Bao.Utils.String.IsNullOrEmpty(self.EndDateTime()) || Number(self.EndDateTime()) >= Number(self.StartDateTime()));
    };
    self.GetInformationDurationReportResult = function (sorting, pageIndex, pageSize, saveFilter) {
        var filterlist = ["StartDateTime", "AreaId", "AreaName", "AreaEquipmentId", "AreaEquipmentName", "Limit"];
        var filter = self.GetFilterHashObject(filterlist, self);
        if (saveFilter === true) {
            self.parent.SaveFilter(filter, sorting, 0);
        }
        self.chartColors = [];
        return Bao.post("ReportCenter/InformationDurationGetReportResult", JSON.stringify({
            filter: filter,
            sorting: sorting,
            pageIndex: pageIndex,
            pageSize: pageSize
        }));
    };
    self.RefreshModels = function () {
        return self.GetInformationDurationReportResult(self.Sorting(), self.PageIndex(), self.PageSize(), true).done(function (result) {
            if (result.Result == true) {
                self.Models(result.Models);
                self.TotalRows(result.TotalRows);
            }
        });
    };
    self.RefreshDiagramModels = function () {
        return self.GetInformationDurationReportResult(self.Sorting(), 0, 0).done(function (result) {
            if (result.Result == true) {
                self.AllModels(result.Models);
            }
        });
    };
    self.resetDefaults = function () {
        self.ReportLoaded(false);
        self.Models([]);
        self.AllModels([]);
        self.PageIndex(self.PageIndexDefault);
        self.PageSize(self.PageSizeDefault);
        self.TotalRows(0);
        self.Sorting([]);
    };
    self.Display = function () {
        if (!self.IsComplete()) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("SelectOneTag"), "info");
            return;
        }
        if (!self.IsValidDateFields()) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("DateTimeFieldsAreInvalid"), "info");
            return;
        }
        parent.TabPage.IsLoading(true);
        self.resetDefaults();
        self.TabViewModel.SelectTab(self.ResultTabList);
        self.RefreshModels().done(function () {
            self.RefreshDiagramModels().done(function () {
                self.ReportLoaded(true);
                parent.TabPage.IsLoading(false);
            }).fail(function () {
                self.ReportLoaded(false);
                parent.TabPage.IsLoading(false);
            });
        }).fail(function () {
            self.ReportLoaded(false);
            parent.TabPage.IsLoading(false);
        });
    };
    self.getInformationDurationReportModel = function () {
        return Bao.post("ReportCenter/InformationDurationGetReportModel", JSON.stringify({}));
    };
    self.init = function () {
        var def = $.Deferred();
        self.getInformationDurationReportModel().done(function (result) {
            ko.map.fromJS(result, self);
            def.resolve();
        });
        def.done(function () {
            self.Initialized(true);
        });
        return def.promise();
    };
    self.loaded = function () {
        self.ResultTabList = new TabPage(null);
        self.ResultTabList.Url("ReportCenter/InformationDurationReportTabResultList");
        self.ResultTabList.AutoSelect = true;
        self.ResultTabList.IsClosable(false);
        self.ResultTabList.PreLoad(true);
        self.ResultTabList.Visible(true);
        self.ResultTabList.ViewModel(new InformationDurationReportTabResultListViewModel(self.TabPage, self));
        self.ResultTabList.Bao = Bao;
        self.TabViewModel.AddTab(self.ResultTabList);
        self.ResultTabDiagram = new TabPage(null);
        self.ResultTabDiagram.Url("ReportCenter/InformationDurationReportTabResultDiagram");
        self.ResultTabDiagram.AutoSelect = false;
        self.ResultTabDiagram.IsClosable(false);
        self.ResultTabDiagram.PreLoad(true);
        self.ResultTabDiagram.Visible(true);
        self.ResultTabDiagram.ViewModel(new InformationDurationReportTabResultDiagramViewModel(self.TabPage, self.DiagramDataSet, self.DiagramTicks));
        self.ResultTabDiagram.Bao = Bao;
        self.TabViewModel.AddTab(self.ResultTabDiagram);
    };

    /** 
     * Convents the given string (yyyymmddhhmmss) to DateTime 
     * @param dateTimeString
     */
    self.ConvertToDateTime = function (dateTimeString) {
        return new Date(dateTimeString.replace(
            /^(\d{4})(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)$/,
            '$4:$5:$6 $2/$3/$1'
        ));
    }

    /**
     * Converts the given DateTime to a string (yyyymmddhhmmss)
     * @param dateTime
     */
    self.ConvertToDateString = function (dateTime) {
        let yyyy = dateTime.getFullYear().toString();
        let MM = self.pad(dateTime.getMonth() + 1, 2);
        let dd = self.pad(dateTime.getDate(), 2);
        let hh = self.pad(dateTime.getHours(), 2);
        let mm = self.pad(dateTime.getMinutes(), 2)
        let ss = self.pad(dateTime.getSeconds(), 2)

        return yyyy + MM + dd + hh + mm + ss;
    }

    /**
     * Adds a 0 in front of the given string in case its less than 10
     * @param stringToPad
     */
    self.pad = function (stringToPad) { return stringToPad < 10 ? '0' + stringToPad : stringToPad }

}
export default InformationDurationReportViewModel;